

<div class="row">

    <div class="col-md-3">
      <div class="card" style="background-color: #3ec59d; border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-1 overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Total Appointments</p>
              <h4 class="mb-0">2</h4>
            </div>
            <div class="text-primary ms-auto">
              <i class=" font-size-24"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="col-md-3">
      <div class="card" style="background-color: #f3a8b5; border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-1 overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Today Appointments</p>
              <h4 class="mb-0">1</h4>
            </div>
            <div class="text-primary ms-auto">
              <i class=" font-size-24"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="col-md-3">
      <div class="card" style="background-color: #8197d1; border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-1 overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Total OP Patients</p>
              <h4 class="mb-0">0</h4>
            </div>
            <div class="text-primary ms-auto">
              <i class=" font-size-24"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="col-md-3">
      <div class="card" style="background-color: #fbd076; border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-1 overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Today OP patients</p>
              <h4 class="mb-0">12</h4>
            </div>
            <div class="text-primary ms-auto">
              <i class=" font-size-24"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </div>
